export class Search {
    private searchButtons: NodeListOf<HTMLElement>;
    private searchBox: HTMLElement;
    private readonly searchResultsPage: boolean;
    private searchInput: HTMLInputElement;
    private closeButton: HTMLButtonElement;
    private searchBoxActive: boolean = false;

    constructor() {
        this.searchButtons = <NodeListOf<HTMLElement>>document.querySelectorAll(".search-btn");
        this.searchBox = document.querySelector(".search-box");
        this.searchResultsPage = this.searchBox.classList.contains("search-box--results");
        this.searchInput = <HTMLInputElement>document.getElementById("search-input");
        this.closeButton = this.searchBox.querySelector(".close-button");

        this.searchButtons.forEach((button: HTMLButtonElement) => {
            button.addEventListener("click", () => {
                if (this.searchResultsPage) {
                    this.focusSearchInputField();
                    return;
                }

                if (this.searchBoxActive) {
                    this.toggleSearchBox(false);
                } else {
                    this.toggleSearchBox(true);
                    this.focusSearchInputField();
                }
            });
        });

        this.closeButton.addEventListener("click", () => {
            this.toggleSearchBox(false);
        });

        if (this.searchResultsPage == false) {
            this.addClickOutsideListener();
        }
    }

    private toggleSearchBox(active: boolean) {
        this.searchBoxActive = active;
        this.searchBox.classList.toggle("active", active);
        this.searchButtons.forEach((button: HTMLButtonElement) => {
            button.classList.toggle("active", active);
        });
        // clear search field input
        this.searchInput.value = "";
    }

    /* focus search input field (set cursor) */
    private focusSearchInputField() {
        this.searchInput.focus();
    }

    private addClickOutsideListener(): void {
        document.addEventListener("click", this.handleClickOutside.bind(this));
    }

    /* close search box on outside click */
    private handleClickOutside(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const isClickInside =
            Array.from(this.searchButtons).some((button) => button.contains(target)) || this.searchBox.contains(target);

        if (!isClickInside) {
            this.toggleSearchBox(false);
        }
    }
}
